<template>
<div>
	<!-- <van-nav-bar
			title="常见问题"
			style="background:linear-gradient(to right,#19CBDA,#2EDD9C);color:#fff;position: fixed;top:0;width:100%"
		>
		<template #left>
			<van-icon @click="onClickLeft" name="arrow-left" color="#fff" size="18" />
		</template>
	</van-nav-bar> -->
	<div class="content">
		
		<!-- <image class="logo" src="/static/head_image.png"></image> -->

		<div class="text-area" v-for="(content,i) in contents" :key="i">
			<h2 class="title">{{content.title}}</h2>
			<ul class="ul">
				<li class="item" v-for="(item,j) in content.items" :key="j">
					{{item}}
				</li>
			</ul>
		</div>

		<p class="tips">如有其它疑问请致电售后服务电话</p>
		<p class="telphone">400-618-0099</p>
	</div>
</div>
	
</template>

<script>
import Vue from 'vue';
import { NavBar } from 'vant';
import { Toast } from 'vant';

	export default {
		data() {
			return {
				title: 'Hello',
				contents: [{
						title: 'APP可以连接哪些蓝牙设备？',
						items: [
							'目前APP可以连接DearBike单车、DearRower划船器、计步器、智能秤，敬请期待更多设备。'
						]
					},
					{
						title: '单车、划船器如何连接？',
						items: [
							'首先请把蓝牙设备开关打开，手机蓝牙打开，进入APP后，在【运动】中进入【连接蓝牙设备】，找到对应的蓝牙编号设备，点击后就可以连接使用了。请注意连接对应的设备区对应的版块中使用。'
						]
					},
					// {
					// 	title: '骑行系统怎么用？',
					// 	items: [
					// 		'骑行系统是一款用于健身房辅助教练教学、学员骑行娱乐的PC系统，针对健身房的单车房开发，配合硬件使用，骑行系统的主要功能有：专业教学区、个人团队竞技、三维实景领骑，APP中的【骑行系统】版块可以让学员升级成为教练，升为教练后可以登录骑行系统带领学员上课。'
					// 	]
					// },
					// {
					// 	title: '扫一扫怎么用？',
					// 	items: [
					// 		'扫一扫可以扫描盒子端系统，PC骑行系统，学员扫描计步器登录。'
					// 	]
					// },
					{
						title: '运动过程中蓝牙断开怎么办？',
						items: [
							'运动中蓝牙断开后程序会自动重连蓝牙设备，或者用户可以保存本次运动数据，手动重连蓝牙设备。'
						]
					},
					// {
					// 	title: 'K币如何获得？有什么用？',
					// 	items: [
					// 		'通过运动里程获得K币，通过完成【我的】-【K币】-【获取K币】种每日任务领取K币。K币可以在【我的】-【K币】-【K币商城】中兑换商品，如DearBike单车、DearRower划船器等。'
					// 	]
					// },
					{
						title: '自由模式中设置阻力不起效果？',
						items: [
							'检查当前连接的蓝牙设备是否为DearBike单车或DearRower划船器。',
							'重启蓝牙设备，重新连接蓝牙设备'
						]
					}
				]
			}
		},
		methods: {
			onClickLeft() {
				// Toast('返回');
				this.$router.go(-1)
			}
		}
	}
</script>

<style>
	/* page{
		background-color: #232943;
	} */
	ul,li{
		list-style: none;
	}
	.content {
		margin-top:10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		font-size: 14px;
		color: #4F5371;
	}

	.logo {
		width: 480px;
		height: 320px;	
	}

	.text-area {
		display: flex;
		background: #fff;
		flex-direction: column;
		justify-content: center;
		margin-bottom:10px;
		border-radius: 10px;
		padding:10px;
		width: 95%;
	}

	.title {
		font-size: 14px;
		color: #23d3bd;
	}

	.ul {
		padding: 0 10px 10px 10px;
		margin: 0;
		
		/* border-bottom: 1px solid #333; */
	}

	.item {
		color: #979797;
		padding-left: 0;
		margin-left: 0;
	}


	.special {
		color: #FEDA2E;
	}

	.tips {
		color: #979797;
	}

	.telphone {		
		margin-top: 20px;
		color: #979797;
	}
</style>
